import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox, Confirm, Grid, Input, Table } from 'semantic-ui-react';
import { SlideDown } from 'react-slidedown';
import { filter, some, sortBy } from 'lodash';
import * as classnames from 'classnames';
import {
  deleteGroupParticipations,
  updateActiveLayerAllGroupParticipations,
  updateActiveLayerGroupParticipations,
  updateGroupParticipationName,
  updateGroupParticipationParticipations
} from '../../../data/analysis/participationsActions';

class GroupParticipation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      colIndexSort: 0,
      reversed: false,
      hidden: false,
      editing: false,
      deleteGroupConfirmOpen: false,
      groupParticipationToDelete: null
    };

    this.setSortingCol = this.setSortingCol.bind(this);
    this.setVisibleSection = this.setVisibleSection.bind(this);
    this.changeParticipationsHandler = this.changeParticipationsHandler.bind(this);
    this.toggleGroup = this.toggleGroup.bind(this);
    this.deleteParticipationGroup = this.deleteParticipationGroup.bind(this);
    this.toggleEditing = this.toggleEditing.bind(this);
    this.updateGroupParticipationName = this.updateGroupParticipationName.bind(this);
    this.cancelDeleteConfirm = this.cancelDeleteConfirm.bind(this);
    this.openDeleteConfirm = this.openDeleteConfirm.bind(this);
    this.toggleAllparticipants = this.toggleAllparticipants.bind(this);
  }

  componentDidMount() {
    this.setState({
      hidden: true
    });
  }

  cancelDeleteConfirm() {
    this.setState({
      deleteGroupConfirmOpen: false,
      groupParticipationToDelete: null
    });
  }

  openDeleteConfirm(groupParticipation) {
    this.setState({
      deleteGroupConfirmOpen: true,
      groupParticipationToDelete: groupParticipation
    });
  }

  setSortingCol(colIndex) {
    this.setState({
      colIndexSort: colIndex,
      reversed: this.state.colIndexSort === colIndex ? !this.state.reversed : false
    });
  }

  setVisibleSection() {
    this.setState({
      hidden: !this.state.hidden
    });
  }

  changeParticipationsHandler(event, data) {
    this.props.dispatch(
      updateGroupParticipationParticipations(
        this.props.groupParticipation.id,
        data.value,
        data.checked
      )
    );
  }

  toggleGroup(event, data) {
    this.props.dispatch(updateActiveLayerGroupParticipations(data.value, data.checked));
  }

  toggleAllparticipants(event, data) {
    this.props.dispatch(
      updateActiveLayerAllGroupParticipations(data.value, this.props.participations, data.checked)
    );
  }

  deleteParticipationGroup() {
    this.props.dispatch(deleteGroupParticipations(this.state.groupParticipationToDelete.id));
    this.cancelDeleteConfirm();
  }

  toggleEditing() {
    this.setState({
      editing: !this.state.editing
    });
  }

  updateGroupParticipationName(e) {
    const { value } = e.target;

    this.setState({
      editing: false
    });

    this.props.dispatch(updateGroupParticipationName(this.props.groupParticipation.id, value));
  }

  render() {
    const self = this;
    const participationsColumns = ['identifier', 'sex', 'birthyear'];

    let sortingColumns = participationsColumns.map((col, i) => {
      const colClassNames = classnames({
        sorting: self.state.colIndexSort === i,
        reversed: self.state.reversed && self.state.colIndexSort === i
      });

      return (
        <Table.Cell key={`participationGroupColumn_${i}`} className={colClassNames}>
          <i
            className="icon icon-play3"
            onClick={() => {
              this.setSortingCol(i);
            }}
          />
        </Table.Cell>
      );
    });

    let groupChecked =
      this.props.participations.length === this.props.groupParticipation.participations.length;

    sortingColumns = [
      sortingColumns,
      <Table.Cell key={`participationGroupColumn_${3}`}>
        <Checkbox
          onClick={this.toggleAllparticipants}
          value={this.props.groupParticipation.id}
          checked={groupChecked}
        />
      </Table.Cell>
    ];

    /**
     * Make basic participation object array
     */
    const participations = filter(this.props.participations, participation => {
      return participation.status === 'valid';
    }).map(participation => {
      const checked = some(this.props.groupParticipation.participations, p => {
        return p === participation.id;
      });
      return {
        id: participation.id,
        identifier: participation.identifier,
        sex:
          participation.participant && participation.participant.sociodemo
            ? participation.participant.sociodemo.sex
            : null,
        birthyear:
          participation.participant && participation.participant.sociodemo
            ? participation.participant.sociodemo.birthyear
            : null,
        checked
      };
    });

    let participationRows = sortBy(participations, p => {
      return p[participationsColumns[self.state.colIndexSort]];
    }).map((p, i) => {
      const rowClassNames = classnames({
        odd: i % 2 === 0
      });

      return (
        <Table.Row key={`participationGroupRow_${i}`} className={rowClassNames}>
          <Table.Cell>{p.identifier}</Table.Cell>
          <Table.Cell>{p.sex}</Table.Cell>
          <Table.Cell>{p.birthyear}</Table.Cell>
          <Table.Cell>
            <Checkbox
              onChange={this.changeParticipationsHandler}
              value={p.id}
              checked={p.checked}
            />
          </Table.Cell>
        </Table.Row>
      );
    });

    /**
     * Reverse check
     */
    if (this.state.reversed) {
      participationRows = participationRows.reverse();
    }

    groupChecked = false;

    if (this.props.groupParticipation && this.props.layer) {
      groupChecked = some(this.props.layer.layer_group_participations_associations, association => {
        return association.group_participations_id === self.props.groupParticipation.id;
      });
    }

    return (
      <Grid.Row className="groupParticipations">
        <Confirm
          key="confirmDelete"
          open={this.state.deleteGroupConfirmOpen}
          cancelButton="Cancel"
          confirmButton="Delete"
          content="Delete Group ?"
          onCancel={this.cancelDeleteConfirm}
          onConfirm={this.deleteParticipationGroup}
        />
        <Grid.Column>
          <Grid>
            <Grid.Row className="groupParticipationHeader">
              <Grid.Column width={2}>
                <i className="icon-user-check" />
              </Grid.Column>
              <Grid.Column width={3}>
                <Checkbox
                  onClick={this.toggleGroup}
                  value={this.props.groupParticipation.id}
                  checked={groupChecked}
                />
              </Grid.Column>
              <Grid.Column width={9}>
                {this.state.editing ? (
                  <Input
                    autoFocus
                    defaultValue={this.props.groupParticipation.name}
                    onBlur={this.updateGroupParticipationName}
                  />
                ) : (
                  <span onClick={this.toggleEditing}>{this.props.groupParticipation.name}</span>
                )}
              </Grid.Column>
              <Grid.Column width={2} className={`toggle ${this.state.hidden ? 'closed' : ''}`}>
                <i className="icon icon-play3 clickable" onClick={this.setVisibleSection} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <SlideDown closed={this.state.hidden} className="boxContent">
            <Table>
              <Table.Header>
                <Table.Row className="sortingRow">{sortingColumns}</Table.Row>
              </Table.Header>
              <Table.Body>
                {participationRows}
                <Table.Row>
                  <Table.Cell
                    onClick={() => {
                      this.openDeleteConfirm(this.props.groupParticipation);
                    }}
                    colSpan={4}
                    className="deleteGroup"
                  >
                    Delete Group
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </SlideDown>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default connect(state => ({}))(GroupParticipation);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/parameters/GroupParticipation.js